import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import HtmlRender from "../../components/HtmlRender/HtmlRender";
import AppBarCustom from "../../components/AppBar";
import React from "react";
const apiUrl = process.env.PORTAL_URL || "http://localhost:7004";
export const News = (data) => {
    var _a;
    return (_jsxs(_Fragment, { children: [_jsx(AppBarCustom, { pages: data.pages || [], navegatePage: data.navegatePage }), _jsxs(Container, { children: [_jsxs(Grid, Object.assign({ container: true, style: { marginTop: 32, marginBottom: 64 } }, { children: [_jsx(Typography, Object.assign({ variant: "h4", component: "h4", mb: 5 }, { children: data === null || data === void 0 ? void 0 : data.noticia.title })), _jsx(Grid, { children: _jsx("img", { src: `${apiUrl}/api/doacao-sangue/assets/${data.noticia.thumbnail}`, alt: "Thumbnail", style: {
                                        width: "100%",
                                        height: "auto",
                                        maxWidth: 600,
                                        maxHeight: 400,
                                        borderRadius: 10,
                                        objectFit: "cover",
                                    } }) })] })), _jsx(HtmlRender, { html: ((_a = data === null || data === void 0 ? void 0 : data.noticia) === null || _a === void 0 ? void 0 : _a.content) || "" })] })] }));
};
